export default __webpack_public_path__ + "static/assets/4df9667fc8897a9f2db9c555c5d6f2b5.png";